import { ReactElement, useContext, useState } from 'react'
import DevelopusSwitchCard from '../../../../../common/ui/grid/DevelopusSwitchCard'
import DevelopusCyrcle from '../../../../../common/ui/design/DevelopusCyrcle'
import DevelopusButton from '../../../../../common/ui/button/DevelopusButton'
import { UserContext } from '../../../context/UserContext'
import UserAction from '../../../context/action/UserAction'
import { UpdateStudentUI } from '../../../model/UpdateStudentUI'
import { UpdateLicenseUI } from '../../../model/UpdateLicenseUI'
import { t } from 'i18next'

interface Props {
  student: UpdateStudentUI
  licenseUI: UpdateLicenseUI
}

const LicenseCard = (props: Props): ReactElement => {
  const context = useContext(UserContext)
  const action = new UserAction(context)

  const [active, setActive] = useState<boolean>(props.licenseUI.active)
  const { vehicleLicense } = props.licenseUI

  const onUpdate = () => {
    action.selectLicense(vehicleLicense.getId())
  }

  const onEnable = () => {
    setActive(true)
    action.addLicense(props.licenseUI)
  }

  const onDisable = () => {
    setActive(false)
    action.removeLicense(props.licenseUI)
  }

  const isSuccessful = props.licenseUI.success
  const id = vehicleLicense.getId()

  return (
    <DevelopusSwitchCard
      checked={active}
      switchable={true}
      onEnable={onEnable}
      onDisable={onDisable}
    >
      <div>
        <div
          style={{
            textAlign: 'right',
          }}
        >
          <DevelopusCyrcle
            width={10}
            color={isSuccessful ? 'green' : '#00000000'}
          />
        </div>
        <div style={{ textAlign: 'center' }}>
          <img
            src={vehicleLicense.getImage()}
            alt="alt text"
            style={{ height: '80px' }}
          />
        </div>
        <h3 style={{ textAlign: 'center' }}>{t(`users.vehicles.${id}`)}</h3>
        <div style={{ width: '100%', textAlign: 'center' }}>
          <DevelopusButton
            text={t('common.update')}
            handleClick={onUpdate}
            disabled={false}
          />
        </div>
      </div>
    </DevelopusSwitchCard>
  )
}

export default LicenseCard
